export default __webpack_public_path__ + "static/media/phone-4.b1c3efb1.svg";